var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      ref: "button",
      staticClass: "button",
      class: _vm.buttonClass,
      attrs: { type: "button", disabled: _vm.disabled },
      on: {
        click: function($event) {
          $event.stopPropagation()
          return _vm.$emit("click")
        }
      }
    },
    [
      _vm.icon
        ? _c("icon", {
            attrs: {
              name: _vm.icon,
              size: _vm.iconSize,
              confirmation: _vm.confirmation
            }
          })
        : _vm._e(),
      _c("span", [_vm._v(_vm._s(_vm.label))]),
      _vm.count
        ? _c("span", { staticClass: "count" }, [_vm._v(_vm._s(_vm.count))])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }